

















import { computed, defineComponent, toRefs } from '@vue/composition-api';
import ALink from '@/components/common/a-link/a-link.vue';
import LinkSvg from '@tt4b/ttam-assets/src/svgs/native-step-link.svg?url';
import AdSetting from '@tt4b/ttam-assets/src/images/creative/ad-settings.png';
import OpenTiktok from '@tt4b/ttam-assets/src/images/creative/open-tiktok.png';
import copyLinkPngEN from '@tt4b/ttam-assets/src/images/creative/copy-link-en.png';
import copyLinkPngJA from '@tt4b/ttam-assets/src/images/creative/copy-link-ja.png';
import copyLinkPngZH from '@tt4b/ttam-assets/src/images/creative/copy-link-zh.png';
import { i18n } from './../../../i18n';
const name = 'ttam-identity-tiktok-post-authorize-guide';
const copyLinkMap = {
  en: copyLinkPngEN,
  ja: copyLinkPngJA,
  zh: copyLinkPngZH,
};
export default defineComponent({
  name,
  components: { ALink },
  props: {
    lang: {
      type: String,
      default: 'en',
    },
  },
  setup(props) {
    const { lang } = toRefs(props);
    const list = computed(() => [
      {
        id: 1,
        img: OpenTiktok,
        desc: i18n.t('module_library_native_open_tiktok'),
      },
      {
        id: 2,
        img: LinkSvg,
      },
      {
        id: 3,
        img: AdSetting,
        desc: i18n.t('module_library_native_ad_settings'),
      },
      {
        id: 4,
        img: LinkSvg,
      },
      {
        id: 5,
        img: copyLinkMap[lang.value] ?? copyLinkMap.en,
        desc: i18n.t('module_library_native_copy_link'),
      },
    ]);
    return {
      name,
      list,
    };
  },
});
